import { Box, Button, HStack, Icon } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';

export * from './base.styled';

export const DetailsBox = Box.withConfig({
  backgroundColor: getDesignToken('background-card'),
  borderRadius: primitive.$borderRadius,
  style: {
    shadowColor: primitive.$shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  paddingY: '$5',
  paddingX: '$6',
  _text: {
    variant: 'copyOne',
    fontSize: 'md',
  },
  marginTop: '$5',
});

export const TextStyled = withTypography({});

export const FieldContainer = Box.withConfig({
  marginBottom: '$4',
  accessible: true,
});

export const PickupTimeHeadingContainer = HStack.withConfig({
  alignItems: 'center',
  marginBottom: '$0',
  marginTop: '$0',
  margin: {
    base: '$0',
  },
  marginX: {
    base: '$4',
  },
  focusable: true,
});

export const PickupDetailsBox = Box.withConfig({
  borderRadius: primitive.$borderRadius,
  marginTop: '$5',
});

export const DetailsWrapper = HStack.withConfig({
  backgroundColor: primitive.$white,
  borderRadius: 10,
  borderBottomRadius: 0,
  padding: '$4',
  flex: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const IconStyled = Icon.withConfig({
  size: 5,
  marginRight: '$1',
});

export const ServiceModesFooter = HStack.withConfig({
  justifyContent: 'flex-end',
  paddingX: '$4',
  paddingY: '$1',
  borderBottomRadius: 10,
  backgroundColor: primitive.$blackOpacity4,
});

export const ChangeServiceModeButton = Button.withConfig<{ isDesktopWeb: boolean }>(props => ({
  minWidth: props.isDesktopWeb ? '$18' : '$16',
  padding: '$2',
  paddingLeft: props.isDesktopWeb ? '$4' : '$3',
  paddingRight: props.isDesktopWeb ? '$4' : '$3',
}));
